import styled, { css } from "styled-components";
import { phoneQuery } from "../../../../styles";

export const Container = styled.div`
	display: flex;
	height: 438px;
	width: 800px;

	${phoneQuery(css`
		width: 100%;
	`)}
`;
